import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  private readonly CHECK_INTERVAL = 3 * 60 * 60 * 1000; // 3 hours

  constructor(private updates: SwUpdate, private snackBar: MatSnackBar) {
    if (this.updates.isEnabled) {
      this.updates.available.subscribe(event => {
        this.promptUser();
      });
      this.periodicCheckForUpdates();
    }
  }

  promptUser(): void {
    const snackBarRef = this.snackBar.open('A new version of MedicAI is available. Reload to update.', 'Reload', {
      duration: 6000,
      panelClass: ['themed-snackbar']
    });

    snackBarRef.onAction().subscribe(() => {
      this.updates.activateUpdate().then(() => document.location.reload());
    });
  }

  private periodicCheckForUpdates(): void {
    setInterval(() => {
      this.updates.checkForUpdate().then(isUpdateAvailable => {
        if (isUpdateAvailable) {
          console.log('New version available.');
        }
      });
    }, this.CHECK_INTERVAL);
  }
}
